import currencyConstants from "../constants/currencyConstants";

const retrieveCurrencies = () => ({
  type: currencyConstants.GET_CURRENCIES_LIST,
});

export default retrieveCurrencies;
